import { Component } from '@angular/core';

/** Nested admin routes (e.g. `/dashboard/admin/notifications`). */
@Component({
  selector: 'app-admin-outlet',
  template: '<router-outlet></router-outlet>',
  standalone: false,
})
export class AdminOutletComponent {}
